var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { customColors } from "./colors/customColors";
import { baseColors } from "./colors/baseColors";
export var createTheme = function (themeColors) {
    var mergedMainColors = __assign(__assign({}, baseColors), themeColors);
    return __assign(__assign(__assign({}, customColors), mergedMainColors), { fonts: {
            sizes: {
                s: '12px',
                m: '13px',
                l: '15px',
                xl: '21px'
            },
            lineHeights: {
                s: '14px',
                m: '16px',
                l: '20px',
                xl: '26px'
            },
            weights: {
                lighter: 200,
                normal: 400,
                semiBold: 600,
                bold: 700
            },
            letterSpacings: {
                xs: 'inherit',
                s: 'inherit',
                m: 'inherit',
                l: 'inherit'
            },
            family: '"Open Sans", sans-serif',
            colors: {
                primary: mergedMainColors.colorTextMain,
                secondary: mergedMainColors.colorTextSecondary,
                light: mergedMainColors.colorTextLight,
                accent: mergedMainColors.colorAccent,
                heading: mergedMainColors.colorTextHeader,
                highlightError: mergedMainColors.colorHighlightErrorDark,
                affect: mergedMainColors.colorTextHeader,
                error: mergedMainColors.colorTextError,
                link: mergedMainColors.colorLink,
                inherit: 'inherit'
            }
        }, spacing: {
            none: '0px',
            xxs: '2px',
            xs: '4px',
            s: '8px',
            m: '16px',
            l: '24px',
            xl: '32px',
            xxl: '48px',
            xxxl: '64px'
        }, sizes: {
            dialog: {
                xxs: { width: '288px', height: '160px' },
                xs: { width: '480px', height: '260px' },
                s: { width: '600px', height: '320px' },
                m: { width: '720px', height: '400px' },
                l: { width: '800px', height: '432px' },
                xl: { width: '880px', height: '560px' },
                xxl: { width: '960px', height: '700px' }
            },
            fields: {
                xxs: '80px',
                xs: '128px',
                s: '176px',
                m: '272px',
                l: '368px',
                xl: '464px',
                xxl: '560px',
                normal: '169px',
                full: '100%'
            }
        }, colors: {
            borders: {
                normal: mergedMainColors.colorBorderMain,
                grid: mergedMainColors.colorBorderGrid,
                error: mergedMainColors.colorBorderError,
                brand: mergedMainColors.colorControlBorderAccent,
                disabled: mergedMainColors.colorBackgroundDisabled
            },
            backgrounds: {
                none: 'transparent',
                normal: mergedMainColors.colorBackgroundBlank,
                neutral: mergedMainColors.colorBackgroundNeutralLight,
                body: '#f1f1e8',
                error: mergedMainColors.colorBackgroundError,
                selection: mergedMainColors.colorHighlightDark,
                hover: mergedMainColors.colorHighlightLight,
                brand: mergedMainColors.colorBackgroundHeader,
                tone: 'rgba(0,0,0, .2)',
                soft: 'rgba(255,255,255, .6)',
                ghost: 'rgba(255,255,255, .01)',
                notification: mergedMainColors.colorHighlightNotification,
                highlight: mergedMainColors.colorHighlightLight,
                highlightDark: mergedMainColors.colorHighlightDark,
                highlightInverted: '#f6f6f6',
                highlightDarkInverted: '#eee',
                disabled: mergedMainColors.colorBackgroundDisabled,
                highlightError: mergedMainColors.colorHighlightErrorLight,
                highlightErrorDark: mergedMainColors.colorHighlightErrorDark
            }
        }, shadows: {
            none: 'none',
            xs: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            s: '0 1px 6px 0 rgba(0, 0, 0, 0.2)',
            m: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
            l: '0 1px 15px 0 rgba(0, 0, 0, 0.2)',
            xl: '0 1px 24px 0 rgba(0, 0, 0, 0.2)',
            xxl: '0 1px 39px 0 rgba(0, 0, 0, 0.2)'
        } });
};
//# sourceMappingURL=createTheme.js.map